import PropTypes from 'prop-types';
import React from 'react';
import { Table } from 'ecs-react-components/dist/index.es';
import * as tableConfig from './TestResultDetailsTableConfig';

const STRUCTURED_CHAR_LIMIT = 20;

export class TestResultDetails extends React.Component {
  renderStructuredTestResult() {
    if (!this.props.testResultDetails) {
      return null;
    }
    const data = this.props.testResultDetails.map((testResult) => {
      const dataRow = testResult;
      if (testResult.abnormalFlag) {
        dataRow.flag = true;
      }
      return dataRow;
    });
    return (
      <Table columns={tableConfig.columns}
        data={data}
      />
    );
  }

  renderNonStructuredTestResult() {
    return (
      <p className="free-text">
        {this.props.testResultDetails[0].testValue}
      </p>
    );
  }

  render() {
    let isNonStructuredTestResult = false;
    if (this.props.testResultDetails && this.props.testResultDetails.length === 1) {
      if (this.props.testResultDetails[0].testValue.length > STRUCTURED_CHAR_LIMIT) {
        isNonStructuredTestResult = true;
      }
    }
    return (
      <div id="test-result-details">
        <h2>{this.props.groupDisplayName}</h2>
        {isNonStructuredTestResult ? this.renderNonStructuredTestResult() : this.renderStructuredTestResult()}
      </div>
    );
  }
}

TestResultDetails.propTypes = {
  groupDisplayName: PropTypes.string,
  testResultDetails: PropTypes.array,
};

export default TestResultDetails;